<template>
    <div class="head">
        <nav class="topNav">
            <img
                src="../assets/images/Mahjong_logo.png"
                ondragstart="return false;"
                alt
                class="logo"
            >
            <ul class="btn_wrap">
                <li v-for="(list,index) in siYuan" :class="{ topNavBtn_actived:changeRed == index}" @click="change(index)"  :key="index">
                    <a>{{list.a}}</a>
                </li>
                <!-- <li class="topNavBtn_actived">
                    <a>{{list.a}}</a>
                </li> -->
            </ul>
            <p class="Follow">Follow us for the latest information releases!</p>
            <a class="Facebook grid" href="https://www.facebook.com/MahjongSoulEN" target="_blank"></a>
			<a class="Twitter grid" href="https://x.com/MahjongSoul_EN" target="_blank"></a>
			<a class="Discord grid" href="http://discord.gg/mahjongsoul" target="_blank"></a>
		</nav>
    </div>
</template>

<script>
export default {
    name: "",

    components: {

    },
    data: () => ({
        siYuan:[
            {"a":"Home"},
            {"a":"Anniversary Board"}
        ],
        changeRed: 1,
        changes:"",
    }),
    created() {

    },
    mounted() {

    },
    watch: {

    },
    computed: {

    },
    methods: {

        change(index){
            this.changeRed = index;
            console.log(this.changeRed)
            if(this.changeRed == 0){
                window.location.replace("https://mahjongsoul.yo-star.com/")
                // this.$router.push('/')
            }
        }

    },
};
</script>

<style lang="scss" scoped>
    .head{
        position: relative;
        .topNav {
            width: 100%;
            height: pxTorem(56px);
            position: absolute;
            top: 0;
            left: 0;
            background: rgba(0, 0, 0, 0.85);
            z-index: 6;
            margin-top:pxTorem(-52px);
            @media screen and (max-width: 600px) {
                height: MpxTorem(50px);
                text-align: center;
                margin-top:MpxTorem(-50px);
            }
            .logo {
                display: block;
                position: absolute;
                width: pxTorem(209px);
                height: auto;
                top: pxTorem(0px);
                left: pxTorem(20px);
                @media screen and (max-width: 600px) {
                    display: none;
                    width: MpxTorem(113px);
                    top: MpxTorem(80px);
                    left: MpxTorem(13px);
                }
            }
            .Follow{
               position: absolute;
               top: 34%;
               font-family: "okayd";
               color: white;
               font-size: pxTorem(18px);
               right: pxTorem(182px);
                @media screen and (max-width: 600px) {
                    display: none;
                }
            }
            .grid{
                width: pxTorem(28px);
                height: pxTorem(28px);
                position: absolute;
                top: 28%;
            }
            .Twitter{
                background: url(../assets/images/ann/Twitter.png);
                background-size: 100% 100%;
                right: pxTorem(138px);
                 @media screen and (max-width: 600px) {
                    display: none;
                }
            }
            .Facebook{
                background: url(../assets/images/ann/Facebook.png);
                background-size: 100% 100%;
                right: pxTorem(102px);
                 @media screen and (max-width: 600px) {
                    display: none;
                }
            }
			.Discord{
				background: url(../assets/images/ann/Discord.png);
				background-size: 100% 100%;
				right: pxTorem(66px);
				@media screen and (max-width: 600px) {
					display: none;
				}
			}
            .btn_wrap {
                height: 100%;
                margin-left: pxTorem(326px);
                @media screen and (max-width: 600px) {
                    margin-left: 0;
                    display: inline-block;
                }

                li {
                    height: 100%;
                    float: left;
                    cursor: pointer;

                    a {
                        display: block;
                        height: 100%;
                        padding: 0 pxTorem(40px);
                        line-height: pxTorem(56px);
                        font-family: "okayd";
                        color: #fff;
                        font-size: pxTorem(40px);
                        transition: opacity 0.64s ease-in-out;
                        @media screen and (max-width: 600px) {
                            padding: 0 MpxTorem(15px);
                            line-height: MpxTorem(50px);
                            font-size: MpxTorem(24px);
                        }
                    }
                }
                .topNavBtn_actived {
                        background: url("../assets/images/topBtn_bg.png") no-repeat;
                        background-size: cover;
                    }
            }
        }
    }
</style>
